










































import 'firebase/messaging'
import userModule from './store/user'
import { Component, Vue } from 'vue-property-decorator'
import { getToken } from 'firebase/messaging'
import { messaging } from '@/plugins/firebase'

@Component({
  name: 'App'
})
export default class App extends Vue {
  private showMobileHint = this.$vuetify.breakpoint.smAndDown
  /*private links = [
    { title: 'Impressum', to: 'imprint' },
    { title: 'AGB', to: 'terms' },
    { title: 'Nutzungsbedingungen', to: 'usage' },
    { title: 'Datenschutz', to: 'privacy' },
    { title: 'FAQ', to: 'faq' },
    { title: 'Presse', to: 'press' },
    { title: 'Jobs', to: 'jobs' }
  ]*/
  private links = [
    { title: 'Impressum', href: 'https://findoo.de/legal/impressum/' },
    { title: 'AGB', href: 'https://findoo.de/legal/agb/' },
    {
      title: 'Nutzungsbedingungen',
      href: 'https://findoo.de/legal/nutzungsbedingungen/'
    },
    { title: 'Datenschutz', href: 'https://findoo.de/legal/datenschutz/' },
    { title: 'FAQ', href: 'https://findoo.de/faq/' },
    { title: 'Presse', href: 'https://findoo.de/presse/' },
    { title: 'Jobs', href: 'https://findoo.de/jobs/' }
  ]

  private openStoreRef(): void {
    if (
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i)
    ) {
      window.open('https://apps.apple.com/de/app/findoo/id1326779278', '_blank')
      return
    }

    // Detect Android
    if (navigator.userAgent.match(/android/i)) {
      window.open(
        'https://play.google.com/store/apps/details?id=io.findoo.app&hl=de',
        '_blank'
      )
      return
    }
    window.open('https://findoo.io', '_blank')
  }

  private async mounted() {
    const webPushToken = await getToken(messaging)
    userModule.updateWebPushToken(webPushToken)
  }
}
